import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getUserError, getUserStatus } from '../store/slices/userSlice';
import $ from "jquery"
import 'datatables.net'
import { getAllPointTable } from '../store/featureActions';

const PointTableList = () => {
    const dispatch = useDispatch()
    const [pointList, setPointList] = useState(null)
    const status = useSelector(getUserStatus)
    const error = useSelector(getUserError)

    const fetchPointTable = async () => {
        try {
            setPointList(null)
            const response = await dispatch(getAllPointTable({ params: false, isToast: false })).unwrap()
            setPointList(response?.data?.points || [])
        } catch (rejectedValueOrSerializedError) {
            console.log(rejectedValueOrSerializedError)
        }
    }

    useEffect(() => {
        let mount = true
        if (mount) {
            fetchPointTable()
        }
        return () => { mount = false }
    }, [])

    useEffect(() => {
        if (pointList) {
            $('#pointTableData').DataTable({
                lengthMenu: [10, 25, 50, 100, 200],
                language: {
                    "emptyTable": "No Point Table Data Found"
                },
                destroy: true,
            });
        }
    }, [pointList])

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginTop: pointList ? "3%" : "12%"
        }}>
            <section className="coupon-sec-2">
                <div className="container tableContainer">
                    <div className="row">
                        <div className="col-12 col-md-12 col-lg-12">
                            <div className="card shadow mb-4">
                                <div className="card-body">
                                    <div className="table-responsive" id="tableready">
                                        <table id="pointTableData" className="table table-bordered display" style={{ width: '100%', textAlign: "center" }}>
                                            <thead>
                                                {pointList ? (
                                                    <tr>
                                                        <th>S.No</th>
                                                        <th>Species</th>
                                                        <th>Family</th>
                                                        <th>Starting Weight (lb oz)</th>
                                                        <th>Ending Weight (lb oz)</th>
                                                        <th>Starting Size (inch)</th>
                                                        <th>Ending Size (inch)</th>
                                                        <th>Points</th>
                                                    </tr>
                                                ) : (<tr></tr>)}
                                            </thead>
                                            <tbody>
                                                {pointList?.map((item, i) => (
                                                    <tr key={i}>
                                                        <td>{i + 1}</td>
                                                        <td>{item?.specieId?.name || "—"}</td>
                                                        <td>{item?.specieId?.family || "—"}</td>
                                                        <td>{item?.startingWeight ?? "—"}</td>
                                                        <td>{item?.endingWeight ? item?.endingWeight : "Infinite"}</td>
                                                        <td>{item?.startingSize ?? "—"}</td>
                                                        <td>{item?.endingSize ? item?.endingSize : "Infinite"}</td>
                                                        <td>{item?.points}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            {!pointList ?
                                                status == "loading" || error ? (
                                                    <tfoot>
                                                        <tr><th>{status == "loading" ? "Loading..." : error ? error : ""}</th></tr>
                                                    </tfoot>
                                                ) : <></> : <></>}
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default PointTableList
